import { SvgIcon, SvgIconProps } from "@mui/material";
import { ReactComponent as ManCampaignIconSvg } from "../../../assets/icons/gestione_campagne.svg";

const IconManageCampaign = (props: SvgIconProps) => (
  <SvgIcon
    component={ManCampaignIconSvg}
    inheritViewBox
    {...props}
    sx={{ ...props.sx, padding: "2px", marginRight: "8px" }}
  />
);

export default IconManageCampaign;
